import { BillingNoticeKey } from './billing-notice-key';
import { BillingNoticeSeverity } from './billing-notice-severity';
import { Billing } from './billing';
import { BillingNoticeAction } from './billing-notice-action';
/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-blacklist, id-match */

export class BillingNotice {
    public key: BillingNoticeKey;
    public severity: BillingNoticeSeverity;
    public data: any;
    public type: BillingNoticeAction;

    public alertTitle(hasOnlyIHDSubscription: boolean) {
        let result = '';

        switch (this.key) {
            case BillingNoticeKey.CANCELLED:
                result = 'Billing.Alert.SubscriptionCancelled.Title';
                break;

            case BillingNoticeKey.PAST_DUE:
                result = 'Billing.Alert.PaymentDeclined.Title';
                break;

            case BillingNoticeKey.UNPAID:
                result = 'Billing.Alert.Unpaid.Title';
                break;

            case BillingNoticeKey.CARD_EXPIRED:
                result = 'Billing.Alert.CardExpired.Title';
                break;

            case BillingNoticeKey.CARD_NEAR_EXPIRY:
                result = 'Billing.Alert.CardNearExpiry.Title';
                break;

            case BillingNoticeKey.TRIAL:
                result = 'Billing.Alert.Trial.Title';
                break;

            case BillingNoticeKey.TRIAL_EXPIRED:
                result = 'Billing.Alert.TrialExpired.Title';
                break;

            case BillingNoticeKey.NO_SOURCE:
                result = hasOnlyIHDSubscription
                    ? 'Billing.Alert.NoSource.OnlyIHDSubscription.Title'
                    : 'Billing.Alert.NoSource.Title';
                break;

            case BillingNoticeKey.NEGATIVE_BALANCE:
                result = 'Billing.Alert.NegativeBalance.Title';
                break;

            case BillingNoticeKey.POSITIVE_BALANCE:
                result = 'Billing.Alert.PositiveBalance.Title';
                break;

            case BillingNoticeKey.PAYMENT_FAILURE:
                result = 'Billing.Alert.PaymentFailure.Title';
                break;
        }

        return result;
    }

    public alertDescription(hasOnlyIHDSubscription: boolean) {
        let result = '';

        switch (this.key) {
            case BillingNoticeKey.CANCELLED:
                result = 'Billing.Alert.SubscriptionCancelled.Desc';
                break;

            case BillingNoticeKey.PAST_DUE:
                result = 'Billing.Alert.PaymentDeclined.Desc';
                break;

            case BillingNoticeKey.UNPAID:
                result = 'Billing.Alert.Unpaid.Desc';
                break;

            case BillingNoticeKey.CARD_EXPIRED:
                result = 'Billing.Alert.CardExpired.Desc';
                break;

            case BillingNoticeKey.CARD_NEAR_EXPIRY:
                result = 'Billing.Alert.CardNearExpiry.Desc';
                break;

            case BillingNoticeKey.TRIAL:
                result = 'Billing.Alert.Trial.DescNew';
                break;

            case BillingNoticeKey.TRIAL_EXPIRED:
                result = 'Billing.Alert.TrialExpired.Desc';
                break;

            case BillingNoticeKey.NO_SOURCE:
                result = hasOnlyIHDSubscription
                    ? 'Billing.Alert.NoSource.OnlyIHDSubscription.Desc'
                    : 'Billing.Alert.NoSource.Desc';
                break;

            case BillingNoticeKey.NEGATIVE_BALANCE:
                result = 'Billing.Alert.NegativeBalance.Desc';
                break;

            case BillingNoticeKey.POSITIVE_BALANCE:
                result = 'Billing.Alert.PositiveBalance.Desc';
                break;

            case BillingNoticeKey.PAYMENT_FAILURE:
                result = 'Billing.Alert.PaymentFailure.Desc';
                break;
        }

        return result;
    }

    public get alertAction() {
        let result = '';

        switch (this.key) {
            case BillingNoticeKey.CANCELLED:
                result = 'Billing.Alert.SubscriptionCancelled.Action';
                break;

            case BillingNoticeKey.TRIAL:
                result = 'Billing.Alert.Trial.Action';
                break;

            case BillingNoticeKey.TRIAL_EXPIRED:
                result = 'Billing.Alert.TrialExpired.Action';
                break;

            case BillingNoticeKey.PAYMENT_FAILURE:
                result = 'Billing.Alert.PaymentFailure.Action';
                break;

            case BillingNoticeKey.POSITIVE_BALANCE:
                result = 'Billing.Alert.PositiveBalance.Desc';
                break;

            case BillingNoticeKey.PAST_DUE:
                result = 'Billing.Alert.PaymentDeclined.Action';
                break;

            case BillingNoticeKey.UNPAID:
                result = 'Billing.Alert.Unpaid.Action';
                break;

            case BillingNoticeKey.CARD_EXPIRED:
                result = 'Billing.Alert.CardExpired.Action';
                break;
        }

        return result;
    }

    public get billingActionType() {
        let result = '';

        switch (this.key) {
            case BillingNoticeKey.CANCELLED:
            case BillingNoticeKey.TRIAL_EXPIRED:
            case BillingNoticeKey.TRIAL:
                result = BillingNoticeAction.UPGRADE;
                break;

            case BillingNoticeKey.PAYMENT_FAILURE:
            case BillingNoticeKey.PAST_DUE:
            case BillingNoticeKey.UNPAID:
            case BillingNoticeKey.CARD_EXPIRED:
                result = BillingNoticeAction.UPDATE_CC_DETAILS;
                break;

            default:
                result = BillingNoticeAction.NO_ACTION;
                break;
        }

        return result;
    }

    public get alertBadge() {
        let result = '';

        switch (this.key) {
            case BillingNoticeKey.PAYMENT_FAILURE:
                result = 'Billing.Alert.PaymentFailure.Badge';
                break;

            case BillingNoticeKey.PAST_DUE:
                result = 'Billing.Alert.PaymentDeclined.Badge';
                break;

            case BillingNoticeKey.UNPAID:
                result = 'Billing.Alert.Unpaid.Badge';
                break;

            case BillingNoticeKey.CARD_EXPIRED:
                result = 'Billing.Alert.CardExpired.Badge';
                break;

            case BillingNoticeKey.CARD_NEAR_EXPIRY:
                result = 'Billing.Alert.CardNearExpiry.Badge';
                break;
        }

        return result;
    }

    public get alertStyle() {
        let cssClass = '';

        switch (this.severity) {
            case BillingNoticeSeverity.INFORMATION:
                cssClass = 'c-alert--info';
                break;
            case BillingNoticeSeverity.WARNING:
                cssClass = 'c-alert--warning';
                break;
            case BillingNoticeSeverity.CRITICAL:
                cssClass = 'c-alert--danger';
                break;
            default:
                cssClass = 'c-alert--info';
        }

        return cssClass;
    }
}
